import { createContext, useContext } from 'react';

export type DocumentPictureInPictureContextValue = {
    /** `document` окна Document PiP (не страницы-opener). */
    pipDocument: Document;
    /** `window` окна Document PiP. */
    pipWindow: Window;
};

export const DocumentPictureInPictureContext = createContext<DocumentPictureInPictureContextValue | null>(null);

DocumentPictureInPictureContext.displayName = 'DocumentPictureInPictureContext';

/**
 * Доступ к `document` / `window` окна Document PiP из потомков, отрендеренных внутри DocumentPictureInPicture.
 */
export function useDocumentPictureInPictureContext(): DocumentPictureInPictureContextValue {
    const value = useContext(DocumentPictureInPictureContext);
    if (!value) {
        throw new Error('useDocumentPictureInPictureContext must be used within DocumentPictureInPicture children');
    }
    return value;
}
